import * as process from 'process';

export const SECOND_URL = process.env.SECOND_URL;
export const WEB_API_ORIGIN = process.env.WEB_API_ORIGIN;
export const LOCAL_API_ORIGIN = process.env.LOCAL_API_ORIGIN;
export const COINCAP_API_ORIGIN = process.env.COINCAP_API_ORIGIN;
export const COINBASE_API_ORIGIN = process.env.COINBASE_API_ORIGIN;
export const METAMASK_DEEP_LINK = process.env.METAMASK_DEEP_LINK;
export const ETHEREUM_NFT_TX = process.env.ETHEREUM_NFT_TX;
export const ETHEREUM_MEMBERSHIP_TX = process.env.ETHEREUM_MEMBERSHIP_TX;
export const ETHEREUM_MARKETPLACE_TX = process.env.ETHEREUM_MARKETPLACE_TX;
export const POLYGON_NFT_TX = process.env.POLYGON_NFT_TX;
export const POLYGON_MEMBERSHIP_TX = process.env.POLYGON_MEMBERSHIP_TX;
export const POLYGON_MARKETPLACE_TX = process.env.POLYGON_MARKETPLACE_TX;
export const APPLICATION_SERVER_KEY = process.env.APPLICATION_SERVER_KEY;
export const INFURA_API_KEY = process.env.INFURA_API_KEY;
export const NETWORK_ENV = process.env.NETWORK_ENV;
